<template>
  <div class="products-from-list">
    <ul>
      <li 
        v-for="(product, index) of list"
        :key="index"
        class="menu-area__search__content__li">
        <router-link :to="{ name: 'single-product', params: { slug: product.fields.slug } }">
          <img
            :srcset="`${product.fields.mainPicture.fields.file.url}?w=250&fit=scale 1x, ${product.fields.mainPicture.fields.file.url}?w=500&fit=scale 2x`"
            :alt="product.fields.mainPicture.fields.description"
            :width="250"
            class="menu-area__search__content__li__img">
          <p v-html="product.fields.title"/>
          <span v-if="typeof product.fields.listingFeatures !== 'undefined'" v-html="product.fields.listingFeatures" />
          <SingleProductListHasTags :product="product" />
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import SingleProductListHasTags from '@/components/SingleProductListHasTags/SingleProductListHasTags.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductsFromList',
  components: {
    SingleProductListHasTags
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./productsList.scss";
</style>
